module.exports = __webpack_public_path__ + "static/media/collapse-before.3ff22e0d.svg";